import axiosClient from "./axiosClient";

// Removes the background from a not-yet-uploaded image file (e.g. a photo picked
// before the product/variant itself exists). Returns a transparent PNG Blob.
export async function removeImageBackground(file) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosClient.post(`/images/remove-background`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    responseType: "blob",
  });
  return response.data;
}
